import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-ss-seller-store",
  "use": "icon-fi-ss-seller-store-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-ss-seller-store\">\r\n  <path d=\"m18,12c-3.314,0-6,2.686-6,6s2.686,6,6,6,6-2.686,6-6-2.686-6-6-6Zm.619,8.414c-.378.378-.88.586-1.414.586h-.002c-.534,0-1.036-.209-1.413-.587l-2.012-2.012,1.414-1.414,2.013,2.013,3.615-3.615,1.414,1.414-3.615,3.615ZM21.802,0l2.198,6.5v.5c0,2.206-1.794,4-4,4h-1c-1.193,0-2.267-.525-3-1.357-.733.832-1.807,1.357-3,1.357h-2c-1.2,0-2.266-.542-3-1.382-.734.84-1.8,1.382-3,1.382h-1c-2.206,0-4-1.794-4-4l.024-.717L2.198,0h4.802v5h2V0h6v5h2V0h4.802Zm-9.076,24H4c-1.654,0-3-1.346-3-3v-8.813c.884.514,1.907.813,3,.813h1c1.062,0,2.095-.288,3-.818.905.53,1.939.818,3,.818h.765c-1.102,1.371-1.765,3.109-1.765,5,0,2.39,1.059,4.533,2.726,6Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-ss-seller-store.svg
// module id = /xiO
// module chunks = 63